import { query, types } from 'typed-graphqlify';
import { gql } from '@apollo/client';

export const locationIdQuery = gql`
  ${query({
    locations: [
      {
        id: types.string,
        name: types.string,
      },
    ],
  })}
`;
